import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { ConfigService } from "src/app/servicios/config/config.service";
import { TitleWrapperService } from "src/app/servicios/title-wrapper/title-wrapper.service";
import { SkeletonImageComponent } from "../skeleton-image/skeleton-image/skeleton-image.component";

@Component({
  selector: "app-logo-menu",
  templateUrl: "./logo-menu.component.html",
  styleUrls: ["./logo-menu.component.scss"],
  imports: [RouterLink, CommonModule, SkeletonImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoMenuComponent implements OnInit {
  @Input() configPrensa: any; // Configuración de la aplicación
  constantesGlobales: any; // Constantes globales de la aplicación
  imagenLogo: any; // URL del logo principal
  configBloque: any; // Configuración específica del bloque

  constructor(
    private readonly titleWrapperService: TitleWrapperService,
    private readonly elementRef: ElementRef,
    private readonly configService: ConfigService,
  ) {}

  /**
   * ngOnInit:
   * - Obtiene las constantes globales y la configuración específica.
   */
  ngOnInit(): void {
    this.constantesGlobales = this.configService.getConstantesGlobales();

    // Función para asegurar que la URL tenga https
    const ensureHttps = (url) => {
      if (!url) return url;
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url.replace("http://", "https://");
      }
      if (url.startsWith("//")) {
        return "https:" + url;
      }
      return "https://" + url;
    };

    if (this.configPrensa) {
      const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
      this.configBloque = this.configPrensa.general[selectorName];
      this.imagenLogo = ensureHttps(this.configBloque.logo);
    }
  }

  /**
   * setDocTitle:
   * - Actualiza el título del documento usando el servicio correspondiente.
   * @param title Nuevo título a establecer.
   */
  setDocTitle(title: string): void {
    this.titleWrapperService.setTitle(title);
  }
}
